export default "__VITE_ASSET__pYzVepSY__"